import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { Modal } from 'react-bootstrap'

// Import menuDropdown
import LanguageDropdown from "../../LanguageDropdown";
import { clearTemporaryStorage, formatDate } from 'helpers/helpers'
import { GET, httpOk, PUT } from "helpers/api";

function Header() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const wrapperRef = useRef(null);
	useOutsideAlerter(wrapperRef);

	const reduxAccount = useSelector(state => state.account)

	const pos = 0
	const [search, setSearch] = useState("")

	const [modalLogout, setModalLogout] = useState(false)
	const [modalConfirm, setModalConfirm] = useState({ show: false, item: {} })
	const [modalRolls, setModalRolls] = useState(false)
	const [showUserDropdown, setShowUserDropdown] = useState(false)

	const [selectedCategory, setSelectedCategory] = useState({
		children: [],
	})
	const [categories, setCategories] = useState([])

	function toggleModalConfirm(bool, item = {}) {
		setModalConfirm({ ...modalConfirm, show: bool, item: item })
		setModalRolls(!bool)
	}

	async function logout() {
		dispatch({ 'type': 'USER_LOGGED_OUT', payload: null })
		clearTemporaryStorage()
		navigate('/auth/login')
	}

	async function openRoll(item) {
		const response = await PUT('/products/open-roll', {
			balance_id: item.balance_id
		}, { loader: true })
		if (httpOk(response)) {
			getCategories()
			toggleModalConfirm(false)
			// setModalRolls(false)
		}
	}

	function useOutsideAlerter(ref) {
		useEffect(() => {
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setShowUserDropdown(false)
				}
			}
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				document.removeEventListener("mousedown", handleClickOutside);
			};
		}, [ref]);
	}

	async function getCategories() {
		const response = await GET('/helper/categories-children')
		if (httpOk(response)) {
			setCategories(response.data)
			if (selectedCategory.id) {
				var index = response.data.findIndex(item => item.id === selectedCategory.id)
				if (index >= 0) {
					setSelectedCategory(response.data[index])
				} else {
					setSelectedCategory(response.data[0])
				}
			} else {
				setSelectedCategory(response.data[0])
			}
		}
	}

	useEffect(() => {
		getCategories()
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	function getCategoriesList() {
		var arr = [...categories]
		if (search) {
			arr = arr.filter(item =>
				item.name.toLowerCase().includes(search.toLowerCase())
			);
		}

		return arr;
	}

	return (
		<>
			<header className="d-between" id="page-topbar" style={{ left: 0 }}>
				<div className="cursor" onClick={() => navigate(-1)}>
					<i className="uil-angle-left-b fz-32 text-black cursor ps-2"></i>
				</div>

				<div className="d-flex align-items-center justify-content-end gap-2">
					<Link className="btn btn-outline-primary" style={{ height: '40px' }} to="/workshop/board">
						<i className="uil-apps me-1"></i>{t('board')}
					</Link>

					<Link className="btn btn-outline-success" style={{ height: '40px' }} to="/workshop/daily-work">
						<i className="uil-file-check-alt me-1"></i>Kunlik ish
					</Link>

					<Link className="btn btn-primary" style={{ height: '40px' }} to="/workshop/documents-preparation">
						{t('preparation')}
					</Link>

					<button className="btn btn-primary" style={{ height: '40px' }} onClick={() => setModalRolls(true)}>
						{t('open_roll')}
					</button>

					<LanguageDropdown />

					<div className="d-lg-inline-block dropdown" >
						<button type="button" className="btn header-item noti-icon waves-effect" ref={wrapperRef}>
							<div className={`profile-dropdown ${pos?.balance < 0 && 'bounce-effect'}`}>
								<div className={`profile-dropdown-toggle ${(pos?.balance > 0 ? 'success' : 'danger')}`}
									onClick={() => setShowUserDropdown(!showUserDropdown)}>
									<i className="uil uil-user" color="#fff"></i>
								</div>
								{showUserDropdown &&
									<div className="profile-dropdown-menu">
										<div className="profile-dropdown-item">
											<div>{t('name')}:</div>
											<div>{reduxAccount.name}</div>
										</div>
										<div className="profile-dropdown-item">
											<div>{t('login')}:</div>
											<div>{reduxAccount.login}</div>
										</div>
										<div className="profile-dropdown-item">
											<div>ID:</div>
											<div>{reduxAccount.id}</div>
										</div>
										<div className="profile-dropdown-item second"
											onClick={() => setModalLogout(true)}>
											<div>
												{t('logout')}
											</div>
											<i className="uil-signin"></i>
										</div>
									</div>
								}
							</div>
						</button>
					</div>
				</div>
			</header>

			<Modal show={modalRolls} animation={false} size="xl" centered
				onHide={() => setModalRolls(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('rolls')}</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ height: '500px', overflow: 'auto' }}>
					<div className="mb-2">
						<label>{t('search')}</label>
						<input autoFocus type="text" className="form-control" value={search}
							onChange={(e) => setSearch(e.target.value)} />
					</div>

					<div className="d-flex">
						<div className="d-flex flex-column gap-1" style={{ width: '300px' }}>
							{getCategoriesList()?.map((item, index) => (
								<div className={`cursor ${item.id === selectedCategory.id ? 'text-primary' : ''}`}
									onClick={() => setSelectedCategory(item)} key={index}>
									{item.name}
								</div>
							))}
						</div>
						<div className="w-100">

							<div>
								<table className="table table-bordered">
									<thead>
										<tr>
											<th style={{ width: '25%' }}>{t('name2')}</th>
											<th style={{ width: '15%' }}>{t('warehouse')}</th>
											<th style={{ width: '10%' }} className="text-end">{t('ton')}</th>
											<th style={{ width: '10%' }} className="text-end">{t('metr')}</th>
											<th style={{ width: '15%' }} className="text-center">{t('date')}</th>
											<th style={{ width: '20%' }} className="text-center"></th>
										</tr>
									</thead>
									<tbody>
										{selectedCategory?.products?.map((item, index) => (
											<tr key={index}>
												<td>{item.name}</td>
												<td>{item.wms_name}</td>
												<td className="text-end">{item.original_quantity}</td>
												<td className="text-end">{item.balance}</td>
												<td className="text-center">{formatDate(item.created_at, "dd.MM.yyyy HH:mm")}</td>
												<td className="text-center p-0">
													<button className="btn btn-primary p-0 w-100 br-0" style={{ height: '30px' }} onClick={() => toggleModalConfirm(true, item)}>
														{t('open2')}
													</button>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</Modal.Body>
			</Modal>


			<Modal show={modalLogout} animation={false}
				centered dialogClassName="update-modal-width"
				onHide={() => setModalLogout(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('logout')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{t('are_you_sure_you_want_logout')}
				</Modal.Body>
				<Modal.Footer >
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => setModalLogout(false)}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100"
							onClick={() => logout()}>
							{t('confirm')}
						</button>
					</div>
				</Modal.Footer>
			</Modal>


			<Modal show={modalConfirm.show} animation={false}
				centered dialogClassName="update-modal-width"
				onHide={() => toggleModalConfirm(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('roll')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{t('are_you_sure_you_want_open_roll')}
				</Modal.Body>
				<Modal.Footer >
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => toggleModalConfirm(false)}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100"
							onClick={() => openRoll(modalConfirm.item)}>
							{t('confirm')}
						</button>
					</div>
				</Modal.Footer>
			</Modal>

		</>
	);
};

export default Header
